import './ItemChat.css'
import {defaultAvatarUrl} from '@utils/Const'
const ItemChatImage = ({avatar, text, data}: any) => {
  return (
    <div className={`chat-message`}>
      <img src={defaultAvatarUrl} alt="Avatar" className="avatar" />
      <div className="message-bot">
        <div>{data?.title}</div>
        <div className={'box-description'}>
          <div className={'text-description'}>{data?.description}</div>
        </div>
        <div>{data?.text_en}</div>
        <div>{data?.text_vn}</div>
      </div>
    </div>
  )
}

export default ItemChatImage
